import { ForecastAnalytics } from './ForecastAnalytics';
import { ForecastParameters } from './ForecastParameters';
import { WeeklyForecast } from './WeeklyForecast';
import { WeeklyForecastComponent } from './WeeklyForecastComponent';

export enum ForecastSourceType {
  SEARCH = 'search',
  PRODUCT = 'product',
}

export interface Forecast {
  id: string;
  date: Date;
  sourceType: ForecastSourceType;
  source: string;
  connector: string;
  startDate: Date;
  endDate: Date;
  model: string;
  parameters: ForecastParameters;
  detectedParameters: ForecastParameters;
  weeklyForecasts?: WeeklyForecast[];
  weeklyForecastComponents?: WeeklyForecastComponent[];
  forecastAnalytics?: ForecastAnalytics;
}
